export type SwapAvailabilityState = 'loading' | 'empty' | 'ready';

export function getSwapAvailabilityState({
  isBalanceLoading,
  availableOptionsCount,
  outputOptionsCount,
}: {
  isBalanceLoading: boolean;
  availableOptionsCount: number;
  outputOptionsCount: number;
}): SwapAvailabilityState {
  if (isBalanceLoading) return 'loading';
  if (availableOptionsCount < 2 || outputOptionsCount === 0) return 'empty';
  return 'ready';
}
